/* eslint-disable prettier/prettier */
import { ProductFragment } from '@core-mkt/shared/craft/product-entry-fragment';
import * as gql from 'fake-tag';

const accordionItems = `
              itemBadge
              itemValueDescriptor
              itemDescription {
                html
              }
              itemTitle
              itemIcon {
                url
                ... on images_Asset {
                  altText
                }
              }
              showDescription`;

export const BundleFragment = {
  Bundle: gql`
    fragment BundleQuery on bundle_Entry {
      bundleAccordionItems1 {
        ... on bundleAccordionItems1Block_Entry {
          ${accordionItems}
        }
      }
      bundleAccordionItems2 {
        ... on bundleAccordionItems2Block_Entry {
          ${accordionItems}
        }
      }
      bundleAccordionItems3 {
        ... on bundleAccordionItems3Block_Entry {
          ${accordionItems}
        }
      }
      topContent
      guaranteeText
      bundles {
      ... on bundlesBlock_Entry {
        bottomContent {
          html
        }
        ctaLabel
        ctaLinkNewTab
        ctaLinkNofollow
        ctaLinkOverride
        ctaStyle
        principalContent {
          html
        }
        product {
          ...ProductEntry
        }
        topContent
        topContentStyles
      }
    }
    lineBreak_bundlesAccordion
    lineBreak_bundlesMainContent
    lineBreak_styles
    styles
    typeHandle
    }
  ${ProductFragment.product}`,
};
